import { jsx as _jsx } from "react/jsx-runtime";
import { components } from 'react-select';
// eslint-disable-next-line
export default function NoOptionsMessage(props) {
    return (_jsx(components.NoOptionsMessage, Object.assign({}, props, { children: _jsx("span", Object.assign({ className: "custom-css-class" }, { children: "Pas d\u2019options" })) })));
}
//# sourceMappingURL=NoOptionsMessage.js.map